import { escapeRegExp } from 'lodash';

export const FilterRe = (value) => new RegExp(`${escapeRegExp(value)}`, 'i');

/**
 * @param {string} input
 * @return {string[]}
 */
export const parseFilterValues = (input) => {
    const values = [];
    let part = '';
    let quote = null;
    let partQuoted = false;

    const pushPart = () => {
        values.push(partQuoted ? part : part.trim());
        part = '';
        partQuoted = false;
    };

    for (let i = 0; i < input.length; i++) {
        const char = input[i];

        if (quote != null) {
            if (char === quote && input[i + 1] === quote) {
                part += char;
                i++;
            } else if (char === quote) {
                quote = null;
            } else {
                part += char;
            }
        } else if (char === "'" || char === '"') {
            if (partQuoted && part.length > 0) {
                pushPart();
            }
            quote = char;
            partQuoted = true;
            part = '';
        } else if (char === ',') {
            pushPart();
        } else if (partQuoted && (char === ' ' || char === '\t')) {
            continue;
        } else {
            partQuoted = false;
            part += char;
        }
    }

    pushPart();
    return values;
};

/**
 * @param {string[]} values
 * @return {string}
 */
export const formatFilterValues = (values) =>
    values.map((value) => (value.includes(',') ? `'${value.replace(/'/g, "''")}'` : value)).join(', ');

export const hasEvenQuotes = (str) =>
    (str.match(/'/g) || []).length % 2 === 0 && (str.match(/"/g) || []).length % 2 === 0;
